export enum REGISTER_AS_ERRORS {
  USER_DELETED = 'USER_DELETED',
  EXISTING_ACCOUNT = 'EXISTING_ACCOUNT',
  LINK_NOT_FOUND = 'LINK_NOT_FOUND',
}

export enum VALIDATION_ERRORS {
  DUPLICATE_ACCOUNT = 'duplicateAccountWarning',
}

export enum VALIDATION_MESSAGES {
  DUPLICATE_ACCOUNT = `There is already an account with that name associated with {organizationName}.  We want to make sure that we do not create a new account if you already have one.\n
    If you believe you already have an account, please click the login button below.  Please note that if you have changed your email address, you will first need to login with your old email address. Once you login, you can then update your email. If you no longer have access to your old email account, please email support@certemy.com.`,
}

export interface RegisterData {
  confirm_password: string;
  email: string;
  first_name: string;
  last_name: string;
  link: string;
  organizationRoleId: number;
  password: string;
  signin_type?: string;
}

